import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { Asset_Status_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface UpdateAssetTRPCInput {
  Id: string;
  Title: string;
  Status: Asset_Status_Enum;
  Description?: null | string;
  AssetType?: null | string;
  SerialNumber?: null | string;
  PurchaseDate?: null | string;
  Location?: null | string;
  Cost?: null | number;
  DepreciationMethod?: null | string;
  Assignee?: null | string;
  OriginalTimestamp: string;
  CustomAttributeData?: CustomAttributeData | null;
  OwnerUserIds: string[];
  OwnerGroupIds: string[];
  ContributorUserIds: string[];
  ContributorGroupIds: string[];
  TagTypeIds: string[];
  DepartmentTypeIds: string[];
}

export const useUpdateAssetTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.asset.update.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.asset.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.asset.assetById.queryKey(),
        });
      },
    }),
  });

  return {
    updateAsset: async (variables: UpdateAssetTRPCInput) => {
      return mutation.mutateAsync(variables);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
